import { Renderer2 } from '@angular/core';

export interface MediaLightboxScrollLock {
  lock(): void;
  unlock(): void;
  reset(): void;
}

export function createMediaLightboxScrollLock(
  documentRef: Document | null | undefined,
  renderer: Renderer2,
  className = 'app-media-lightbox-scroll-locked'
): MediaLightboxScrollLock {
  let locked = false;

  return {
    lock(): void {
      const body = documentRef?.body;
      if (!body || locked) {
        return;
      }
      renderer.addClass(body, className);
      locked = true;
    },
    unlock(): void {
      const body = documentRef?.body;
      if (!body || !locked) {
        return;
      }
      renderer.removeClass(body, className);
      locked = false;
    },
    reset(): void {
      const body = documentRef?.body;
      if (!body) {
        return;
      }
      renderer.removeClass(body, className);
      locked = false;
    },
  };
}
